import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@carbon/react';
import { Locked } from '@carbon/icons-react';

/**
 * 403 - Nemate pristup
 * Prikazuje se kada korisnik pokuša da pristupi ruti za koju nema dozvolu.
 */
const Forbidden = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: '60vh',
        padding: '2rem',
        gap: '1rem',
      }}
    >
      <Locked size={48} style={{ color: '#9fb746' }} />
      <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>
        Nemate pristup
      </h1>
      <p style={{ margin: 0, maxWidth: '32rem', color: '#525252' }}>
        Nemate dozvolu za pristup ovoj stranici. Obratite se administratoru
        ustanove ako smatrate da je ovo greška.
      </p>
      <Button as={Link} to="/" kind="primary">
        Nazad na početnu
      </Button>
    </div>
  );
};

export default Forbidden;
